<header class="page-head" data-testid="sms-validation-section">
  <div class="page-head__identity">
    <span class="page-head__icon"><i class="fa fa-shield"></i></span>
    <div>
      <h1 class="page-head__title">Validação de SMS Massivo</h1>
      <p class="page-head__subtitle">
        Leia a mensagem, confira o link e aprove ou reprove com justificativa. As abas abaixo
        separam o que está esperando revisão do que já foi decidido.
      </p>
    </div>
  </div>
</header>

<form [formGroup]="broadcastForm" (ngSubmit)="search()">
  <div class="m8v-filter-bar" data-testid="sms-validation-filter-bar">
    <div class="m8v-search grow">
      <i class="fa fa-search ic"></i>
      <input
        type="text"
        class="form-control"
        placeholder="Nome do envio massivo"
        formControlName="text"
        name="text"
        data-testid="input-text"
      />
    </div>
    <div class="m8v-search grow">
      <i class="fa fa-user ic"></i>
      <input
        type="text"
        class="form-control"
        placeholder="Usuário · nome ou e-mail"
        formControlName="author"
        name="author"
        data-testid="input-author"
      />
    </div>
    <div class="m8v-period">
      <i class="fa fa-calendar-o ic"></i>
      <input type="date" formControlName="startDate" name="startDate" data-testid="input-start-date" />
      <span class="sep">até</span>
      <input type="date" formControlName="endDate" name="endDate" data-testid="input-end-date" />
    </div>
  </div>

  <small class="text text-danger" *ngIf="invalidTime" data-testid="invalid-period">
    Período inválido.
  </small>

  <div class="m8v-filter-bar m8v-filter-bar--selects" data-testid="sms-validation-filter-bar-2">
    <div class="m8v-seg" data-testid="validation-tabs">
      <button
        type="button"
        *ngFor="let tab of tabs"
        [class.on]="activeTab === tab.key"
        (click)="setTab(tab.key)"
        [attr.data-testid]="'tab-' + tab.key"
      >
        {{ tab.label }} <span class="n">{{ counts[tab.key] }}</span>
      </button>
    </div>

    <div class="field" style="margin-left: auto">
      <select
        class="form-select"
        name="orderBy"
        formControlName="orderBy"
        (change)="listPaginated()"
        data-testid="select-order-by"
      >
        <option value="created_at">Ordenar por data</option>
        <option value="broadcast_status_id">Ordenar por status</option>
        <option value="leads_count">Ordenar por leads</option>
      </select>
    </div>

    <app-switcher
      class="m8v-switch-inline"
      label="Inverter"
      [checked]="broadcastForm.value.invertedOrder"
      (checkedChange)="invertOrder()"
      data-testid="switch-invert-order"
    ></app-switcher>

    <button type="submit" class="sf-btn sf-btn--primary" [disabled]="invalidTime" data-testid="btn-search">
      <i class="fa fa-search"></i> Pesquisar
    </button>
    <button type="button" class="sf-btn sf-btn--ghost clear" (click)="clearFilters()" data-testid="btn-clear">
      <i class="fa fa-times"></i> Limpar
    </button>
  </div>
</form>

<section>
  <app-skeleton *ngIf="loading" variant="table-row" [count]="4" [columns]="3"
    label="Carregando os envios para validação" data-testid="sms-validation-loading"></app-skeleton>

  <div class="notice notice--danger" *ngIf="!loading && loadError" data-testid="sms-validation-error">
    <i class="fa fa-exclamation-triangle"></i>
    <div class="notice__body">
      {{ loadError }}
      <button type="button" class="sf-btn sf-btn--secondary sf-btn--sm" (click)="retry()" data-testid="sms-validation-retry">
        Tentar de novo
      </button>
    </div>
  </div>

  <div *ngIf="!loading && !loadError && (!result?.data || result.data.length === 0)" class="m8v-empty" data-testid="sms-validation-empty">
    <i class="fa fa-shield ic"></i>
    <h3>Nenhum envio em massa para validação!</h3>
    <p *ngIf="activeTab === 'pending'">
      Nenhum envio está "Pendente Análise" agora. Veja as abas Aprovados/Reprovados para o histórico.
    </p>
    <p *ngIf="activeTab !== 'pending'">Nada bate com os filtros nesta aba.</p>
  </div>

  <div class="m8v-val-list" *ngIf="!loading && !loadError && result?.data?.length > 0">
    <div class="m8v-val-card" *ngFor="let broadcast of result.data" data-testid="sms-validation-card">
      <div class="info">
        <div class="name">
          <span class="m8v-name-link">{{ broadcast.name }}</span>
          <span
            class="m8v-status-pill m8v-status-pill--sm"
            [ngClass]="'m8v-status-pill--' + statusTone(broadcast)"
            data-testid="status-pill"
          >
            <span class="dot"></span>{{ broadcast.broadcast_status_id | broadcastStatus }}
          </span>
          <span class="m8v-meta-chip" *ngIf="broadcast.broadcast_type?.name">
            <i class="fa fa-tag ic"></i>{{ broadcast.broadcast_type?.name }}
          </span>
          <span class="m8v-meta-chip"><i class="fa fa-users ic"></i>{{ broadcast.leads_count }} leads</span>
        </div>

        <div class="field">
          <label>Mensagem</label>
          <div class="m8v-msg-bubble">{{ getMessage(broadcast) }}</div>
        </div>

        <div class="field" *ngIf="broadcast.short_url">
          <label>URL original</label>
          <span class="m8v-copy-field">
            <code>{{ broadcast.url }}</code>
            <a [href]="broadcast.url" target="_blank" class="sf-btn sf-btn--ghost sf-btn--icon sf-btn--sm" title="Abrir em outra aba">
              <i class="fa fa-external-link"></i>
            </a>
          </span>
          <span class="field-hint">Encurtada para {{ broadcast.short_url }} no envio.</span>
        </div>
      </div>

      <div class="side">
        <dl class="m8v-def-grid">
          <div class="m8v-def">
            <dt>Usuário</dt>
            <dd *ngIf="broadcast.user; else noUser" data-testid="broadcast-user">
              {{ broadcast.user.name }}<br *ngIf="broadcast.user.email" /><small *ngIf="broadcast.user.email">{{ broadcast.user.email }}</small>
            </dd>
            <ng-template #noUser><dd data-testid="broadcast-user">Desconhecido</dd></ng-template>
          </div>
          <div class="m8v-def">
            <dt>Data do envio</dt>
            <dd>{{ getDate(broadcast) | date:'dd/MM/yyyy' }}</dd>
          </div>
          <div class="m8v-def" *ngIf="activeTab === 'approved'" data-testid="broadcast-reviewer">
            <dt>Aprovado por</dt>
            <dd>{{ broadcast.reviewer ? broadcast.reviewer.name : '—' }}</dd>
          </div>
          <div class="m8v-def" *ngIf="activeTab === 'approved'" data-testid="broadcast-reviewed-at">
            <dt>Aprovado em</dt>
            <dd>{{ broadcast.reviewed_at ? (broadcast.reviewed_at | date:'dd/MM/yyyy') : '—' }}</dd>
          </div>

          <div class="m8v-def" *ngIf="activeTab === 'rejected'" data-testid="broadcast-reviewer">
            <dt>Reprovado por</dt>
            <dd>{{ broadcast.reviewer ? broadcast.reviewer.name : '—' }}</dd>
          </div>
          <div class="m8v-def" *ngIf="activeTab === 'rejected'" data-testid="broadcast-reviewed-at">
            <dt>Reprovado em</dt>
            <dd>{{ broadcast.reviewed_at ? (broadcast.reviewed_at | date:'dd/MM/yyyy') : '—' }}</dd>
          </div>
          <div class="m8v-def wide" *ngIf="activeTab === 'rejected'" data-testid="broadcast-reject-reason">
            <dt>Motivo</dt>
            <dd>{{ broadcast.reason || '—' }}</dd>
          </div>
        </dl>

        <div class="acts" *ngIf="activeTab === 'pending'">
          <button
            type="button"
            class="sf-btn sf-btn--primary"
            (click)="approve(broadcast)"
            [disabled]="!isPendingReview(broadcast)"
            data-testid="btn-approve"
          >
            <i class="fa fa-check"></i> Aprovar
          </button>
          <button
            type="button"
            class="sf-btn sf-btn--secondary"
            (click)="cancel(broadcast)"
            [disabled]="!isPendingReview(broadcast)"
            data-testid="btn-cancel"
          >
            <i class="fa fa-ban"></i> Cancelar
          </button>
        </div>
      </div>
    </div>
  </div>

  <app-pagination *ngIf="!loading && !loadError && result" [currentPage]="result.current_page" [itemsPerPage]="result.per_page"
    [totalItems]="result.total" (pageChanged)="pageChanged($event)"></app-pagination>
</section>

<ng-template #modalValidation let-modal>
  <div class="modal-header">
    <h5 class="modal-title" data-testid="cancel-modal-title">
      <i class="fa fa-ban"></i> Cancelamento <span class="sub">{{ broadcast?.name }}</span>
    </h5>
    <button
      type="button"
      class="sf-btn sf-btn--ghost sf-btn--icon sf-btn--sm"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <i class="fa fa-times"></i>
    </button>
  </div>

  <div class="modal-body">
    <dl class="m8v-def-grid">
      <div class="m8v-def">
        <dt>Data do envio</dt>
        <dd>{{ getDate(broadcast) | date:'dd/MM/yyyy' }}</dd>
      </div>
      <div class="m8v-def">
        <dt>Usuário</dt>
        <dd *ngIf="broadcast?.user; else noUserModal" data-testid="modal-broadcast-user">
          {{ broadcast.user.name }} <small>({{ broadcast.user.email }})</small>
        </dd>
        <ng-template #noUserModal><dd data-testid="modal-broadcast-user">Desconhecido</dd></ng-template>
      </div>
      <div class="m8v-def wide">
        <dt>Mensagem</dt>
        <dd><div class="m8v-msg-bubble">{{ getMessage(broadcast) }}</div></dd>
      </div>
    </dl>

    <div class="field">
      <label>Justificativa <span class="required">*</span></label>
      <textarea
        class="form-control"
        rows="3"
        placeholder="Explique ao cliente por que o envio foi cancelado"
        [(ngModel)]="reason"
        name="reason"
        data-testid="input-reason"
      ></textarea>
      <span class="field-error" *ngIf="reasonError" data-testid="reason-error">
        <i class="fa fa-exclamation-triangle"></i> Justificativa é obrigatória!
      </span>
      <span class="field-hint">O cliente vê este texto como "Motivo do cancelamento" na lista e no detalhe.</span>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="sf-btn sf-btn--secondary" (click)="modal.dismiss()" data-testid="btn-modal-close">
      Fechar
    </button>
    <button type="button" class="sf-btn sf-btn--danger" (click)="disapprove()" data-testid="btn-modal-cancel">
      <i class="fa fa-ban"></i> Cancelar broadcast
    </button>
  </div>
</ng-template>
